<template>
    <b-badge v-if="sectionName != null" variant="light" class="mr-2">
        {{ sectionName }}
    </b-badge>
</template>

<script>
export default {
    name: 'SectionBadge',
    props: ['entity', 'entityType'],
    computed: {
        sectionName: function() {
            if (this.entityType == 'keyResults') {
                return this.entity.objective.section_id
                    ? this.entity.objective.section.name
                    : null
            }
            return this.entity.section_id ? this.entity.section.name : null
        },
    },
}
</script>
